export default __webpack_public_path__ + "static/media/IBMPlexSans-MediumItalic-Latin1.a6573cf2.woff2";